<template>
  <fragment>
    <template v-if="isNotFound">
      <PageNotFound />
    </template>
    <template v-else>
      <main class="ws-page">
        <ws-study-groups-list v-if="!isLoading" :org="org" />
      </main>
    </template>
  </fragment>
</template>

<script>
import { mapActions } from 'vuex'
import { Fragment } from 'vue-fragment'
import PageNotFound from '@/views/PageNotFound'
export default {
  name: 'Groups',
  components: { Fragment, PageNotFound },
  data () {
    return {
      org: {},
      isLoading: false,
      isNotFound: false
    }
  },
  computed: {
    getEducationGuid () {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapActions('public/refbook/education/institution', ['get'])
  },
  async created () {
    try {
      this.isLoading = true
      this.org = await this.get([this.getEducationGuid])
    } catch (e) {
      if (e && e.code === 404) {
        this.isNotFound = true
      }
    } finally {
      this.isLoading = false
    }
  }
}
</script>
